module.exports = __webpack_public_path__ + "static/media/chat12.dd80924c.svg";